import React from 'react';
import {useSelector} from 'react-redux';
import type {RootState} from "../../stores";
import {app} from "../../modules/config.ts";
import {Utils} from "../../modules/utils.ts";


const Modal: React.FC = () => {
  let { isOpen, type, } = useSelector((state: RootState) => state.modal);

  if (!isOpen) return null;

  const getComponent = () => {
    switch (type) {
      case 'offline':
        return <div style={{ padding: '1rem' }}>
          <h2>인터넷 연결 끊김</h2>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <p>현재 오프라인 상태로 {app.name} 서버와 연결이 끊겼습니다.</p>
            <p>인터넷 연결을 확인하세요.</p>
            {
              Utils.isMobileOrTableDevice() &&
                <>
                  <p>재생이 원활하지 않으면 아래 버튼으로 <span style={{color: '#ff6b6b', fontWeight: 'bold'}}>오프라인 페이지</span>로 이동하세요.</p>
                  <p>온라인되면 자동으로 복구됩니다.</p>
                  <button type="button" className="btn on" onClick={() => window.location.reload()}>오프라인 페이지</button>
                </>
            }
          </div>
        </div>;
      default:
        isOpen = false;
        break;
    }
    return
  };

  return (
    <div className={`modal popup ${isOpen ? 'on' : ''}`}>
      <div className="modal-content">
        {getComponent()}
      </div>
    </div>
  );
};

export default Modal;